"use strict";
// Shared DTOs for operational Incidents.
Object.defineProperty(exports, "__esModule", { value: true });
exports.incidentOverlaps = exports.isIncidentActive = exports.IncidentIssue = exports.IncidentImpact = void 0;
/**
 * The operational effect an incident is having on the field.
 *
 * Lives here rather than on the entity so DTO consumers (command console, NOC
 * UI) can reference it without pulling in TypeORM — the same reason
 * `AlertSeverity` lives in ./alerts. `Incident.impact` imports it from here.
 */
var IncidentImpact;
(function (IncidentImpact) {
    IncidentImpact["CHARGER_OFFLINE"] = "CHARGER_OFFLINE";
    IncidentImpact["BESS_OFFLINE"] = "BESS_OFFLINE";
    IncidentImpact["SITE_OFFLINE"] = "SITE_OFFLINE";
})(IncidentImpact = exports.IncidentImpact || (exports.IncidentImpact = {}));
/**
 * The root cause (or suspected root cause) of an incident.
 */
var IncidentIssue;
(function (IncidentIssue) {
    IncidentIssue["SUSPECTED_POWER_OUTAGE"] = "SUSPECTED_POWER_OUTAGE";
    IncidentIssue["CONFIRMED_POWER_OUTAGE"] = "CONFIRMED_POWER_OUTAGE";
    IncidentIssue["VANDALISM"] = "VANDALISM";
    IncidentIssue["THIRD_PARTY_DAMAGE"] = "THIRD_PARTY_DAMAGE";
    IncidentIssue["PREVENTATIVE_MAINTENANCE"] = "PREVENTATIVE_MAINTENANCE";
    IncidentIssue["FORCE_MAJEURE"] = "FORCE_MAJEURE";
    IncidentIssue["TELECOMMUNICATIONS_FAILURE"] = "TELECOMMUNICATIONS_FAILURE";
    IncidentIssue["HARDWARE_FAILURE"] = "HARDWARE_FAILURE";
    IncidentIssue["COMMISSIONING"] = "COMMISSIONING";
})(IncidentIssue = exports.IncidentIssue || (exports.IncidentIssue = {}));
/**
 * Whether an incident is still live.
 *
 * An incident is live while it has no end recorded *or* its end is still in the
 * future — a planned window that has not closed yet is every bit as active as
 * one with no end at all. Both the `ongoingOnly` list filter and the UI badge
 * are defined by this, so a row shown as live is exactly a row the filter
 * returns.
 *
 * `end` arrives as a string over HTTP and a `Date` in-process, so both are
 * accepted. `now` is injectable for tests.
 */
function isIncidentActive(end, now = new Date()) {
    return end == null || new Date(end).getTime() > now.getTime();
}
exports.isIncidentActive = isIncidentActive;
/**
 * Whether an incident's window overlaps the window `[start, end]`.
 */
function incidentOverlaps(incident, start, end) {
    return (new Date(incident.beginning).getTime() <= end.getTime() &&
        (incident.end == null || new Date(incident.end).getTime() > start.getTime()));
}
exports.incidentOverlaps = incidentOverlaps;
